module.exports = __webpack_public_path__ + "static/media/signature-small.44be1a3a.png";